import { loginAsync } from 'utils/auth';
import { createReducer } from 'utils/reduxCreators';
import { oidcConfig } from 'config';
import { putTcAccepted } from 'services/termsAndConditions';

export const CHECK_USER_AUTHENTICATED = 'auth/CHECK_USER_AUTHENTICATED';
export const UPDATE_TERMS_CONDITIONS = 'auth/UPDATE_TERMS_CONDITIONS';

const initialState = {
  isAuthenticated: false,
  permissions: [],
  userId: -1,
  userName: null,
  parentUserId: null,
  parentUserName: null,
  fullName: null,
  email: null,
  hasAcceptedTC: true,
  accessToken: null,
  idToken: null,
};

export default createReducer(initialState, {
  [CHECK_USER_AUTHENTICATED]: (state, { payload }) => {
    return { ...state, ...payload };
  },
  [UPDATE_TERMS_CONDITIONS]: (state, { payload }) => {
    return { ...state, hasAcceptedTC: payload };
  },
});

export const checkLogin = (params, value) => async (dispatch, getState) => {
  const user = await loginAsync(oidcConfig);
  if (!user || user.expired) {
    dispatch({ type: CHECK_USER_AUTHENTICATED, payload: initialState });
  } else {
    const data = {
      isAuthenticated: true,
      permissions: user.profile.web_user_permissions.split(','),
      userId: user.profile.web_user_id,
      parentUserId: user.profile.web_user_parentid,
      parentUserName: user.profile.web_user_parent_username,
      fullName: user.profile.web_user_fullname,
      email: user.profile.web_user_email,
      hasAcceptedTC:
        user.profile.web_user_accepted_terms &&
        user.profile.web_user_accepted_terms.toLowerCase() === 'true',
      accessToken: user.access_token,
      idToken: user.id_token,
    };
    dispatch({ type: CHECK_USER_AUTHENTICATED, payload: data });
  }
};

export const updateTcAccepted = (isAccepted) => async (dispatch) => {
  const tcAccepted = await putTcAccepted(isAccepted);
  // todo payload status from response
  dispatch({ type: UPDATE_TERMS_CONDITIONS, payload: tcAccepted });
};
